type AuthLogoHeaderProps = {
    id?: string;
    heading: string;
    description?: React.ReactNode;
};

const AuthLogoHeader = ({ id, heading, description }: AuthLogoHeaderProps) => {
    return (
        <div className="gs-auth-header">
            <div className="gs-auth-logo-wrap">
                <img
                    id={`${id}-page-logo`}
                    className="gs-auth-logo"
                    src="/images/logo.png"
                    alt="GreenSign"
                />
            </div>
            <h5 className="gs-auth-heading" id={`${id}-page-heading`}>
                {heading}
            </h5>
            {description ? <p className="gs-auth-description">{description}</p> : null}
        </div>
    );
};

export default AuthLogoHeader;
